var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{class:['form-textarea', _vm.stateName],attrs:{"name":_vm.name,"id":_vm.id,"maxlength":_vm.maxLengthComputed},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }